/** @jsx jsx */
import { animated, useSpring } from "react-spring"
import { IconMagnifyingGlass } from "icons/MagnifyingGlass"
import { jsx, Box, Input } from "theme-ui"
import * as styles from "./styles"
import React from "react"

interface SearchInputProps {
  className?: string
  onSearchChange: (value: string) => void
}

const AnimatedBox = animated(Box)

export const SearchInput: React.FC<SearchInputProps> = ({
  className,
  onSearchChange,
}) => {
  const [value, setValue] = React.useState<string>("")
  const [focussed, setFocussed] = React.useState<boolean>(false)
  const isFilled = value !== ""
  const isExpanded = isFilled || focussed
  const props = useSpring({
    width: isExpanded ? "100%" : "75%",
    config: { mass: 1, tension: isExpanded ? 400 : 200, friction: 20 },
  })

  const onChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { value } = event.target as HTMLInputElement
    setValue(value)
    onSearchChange(value)
  }

  const input = React.useRef<HTMLInputElement>(null)

  const handleFocus = () => {
    input.current.addEventListener("keydown", removeFocus, false)
    setFocussed(true)
  }

  const handleBlur = () => {
    input.current.removeEventListener("keydown", removeFocus, false)
    setFocussed(false)
  }

  const removeFocus = ({ key }: { key: string }) => {
    if (key === "Escape") {
      input.current.blur()
    }
  }

  return (
    <AnimatedBox className={className} sx={styles.root} style={props}>
      <Box sx={styles.iconBox}>
        <IconMagnifyingGlass width={16} height={16} strokeWidth={4} />
      </Box>
      <Input
        onChange={onChange}
        defaultValue={value}
        placeholder="Search by name or description..."
        onFocus={() => handleFocus()}
        onBlur={() => handleBlur()}
        ref={input}
        sx={{
          ...styles.input,
          ...(isFilled ? { bg: "white" } : {}),
        }}
      />
    </AnimatedBox>
  )
}
